/** Theme mode: the user's choice, stored per browser. public/theme-boot.js applies it before first paint. */
export type ThemeMode = 'system' | 'light' | 'dark';

export const THEME_STORAGE_KEY = 'rgs.theme';
const MODES: readonly ThemeMode[] = ['system', 'light', 'dark'];

export function readThemeMode(storage: Pick<Storage, 'getItem'> | undefined = globalThis.localStorage): ThemeMode {
  try {
    const v = storage?.getItem(THEME_STORAGE_KEY);
    return MODES.includes(v as ThemeMode) ? (v as ThemeMode) : 'system';
  } catch {
    return 'system';
  }
}

export function writeThemeMode(
  mode: ThemeMode,
  storage: Pick<Storage, 'setItem'> | undefined = globalThis.localStorage,
) {
  try {
    storage?.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    // Private mode or blocked storage: the choice lasts for this page only.
  }
}

export const resolveDark = (mode: ThemeMode, prefersDark: boolean) =>
  mode === 'dark' || (mode === 'system' && prefersDark);

export function applyDarkClass(dark: boolean, root: HTMLElement = document.documentElement) {
  root.classList.toggle('dark', dark);
  root.style.colorScheme = dark ? 'dark' : 'light';
}
